import React from 'react';

import './UserMenu.css';

export const MenuSectionHeader: React.FC<{ title: string }> = ({ title }) => (
  <div role="heading" aria-level="2" className="menu-section-header">
    {title}
  </div>
);
